import { useEffect, useState } from 'react';

/**
 * Laedt das Motion-Kit (GSAP + EachOtter-Bausteine) erst, wenn eine Seite es
 * braucht. Nur die oeffentlichen Seiten (Landingpage, /start) nutzen es; im
 * Haupt-Bundle und in der eingeloggten App landet nichts davon.
 *
 * Ein einziger Ladevorgang pro Seitenaufruf (Modul-Promise), egal wie viele
 * Sektionen gleichzeitig danach fragen. Schlaegt der Chunk fehl (z. B. nach
 * einem Deploy mit neuen Hashes), wird der naechste Aufruf es erneut versuchen,
 * statt fuer immer auf einem abgelehnten Promise zu sitzen.
 */
let kitPromise = null;

export const loadMotionKit = () => {
  if (!kitPromise) {
    kitPromise = import(/* webpackChunkName: "motion-kit" */ '../motion-kit').catch((error) => {
      kitPromise = null;
      throw error;
    });
  }
  return kitPromise;
};

/**
 * Startet den Ladevorgang erst, wenn die Seite steht (load) und der Browser
 * Luft hat: Auf dem Telefon konkurrieren Kit und GSAP sonst mit Haupt-Bundle
 * und Schriften um die Leitung — und die H1 (LCP) wartet. Nach einem
 * Seitenwechsel innerhalb der App ist load laengst durch, dann geht es sofort
 * in den naechsten Leerlauf.
 */
const whenIdle = (fn) => {
  let cancelIdle = () => {};
  const idle = () => {
    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(fn, { timeout: 1200 });
      cancelIdle = () => window.cancelIdleCallback(id);
    } else {
      const id = setTimeout(fn, 200);
      cancelIdle = () => clearTimeout(id);
    }
  };
  if (typeof document === 'undefined' || document.readyState === 'complete') {
    idle();
    return () => cancelIdle();
  }
  window.addEventListener('load', idle, { once: true });
  return () => { window.removeEventListener('load', idle); cancelIdle(); };
};

const useMotionKit = () => {
  const [kit, setKit] = useState(null);
  useEffect(() => {
    let alive = true;
    const cancel = whenIdle(() => {
      loadMotionKit()
        .then((mod) => { if (alive) setKit(mod); })
        .catch(() => { /* Ohne Kit bleiben die statischen Fallbacks stehen. */ });
    });
    return () => { alive = false; cancel(); };
  }, []);
  return kit;
};

export default useMotionKit;
